import { Checkbox, Modal, Button } from '@scuf/common';
import React, { useState, useEffect } from 'react';
import './ExportAnomaly.scss';
import { useSelector, useDispatch } from 'react-redux';
import { addExportFilter, clearExportFilter, getAllExportFiltersSelector, getExportLookupSelector } from 'src/slices/allOpportunitySlice';
import { getExportLookup } from '../../slices/allOpportunitySlice';
import { EXPORT_LOOKUP_CONSTANTS } from 'src/constants/constants';
import { getCurrentRole } from "src/slices/onBoardingSlice";
import { tagEvent } from 'src/utils/analytics/analytics.service.util';


interface IExportAnomaly {
    showExportPopup: boolean
    toggleClose: Function
    downloadExportData:Function
    selectedInsightId:string[]
    uniqueDomain:any
    exportAnomayColumns?:string[]
    isOrphan?:boolean
}
interface IDomainExportData{
    text:string
    isChecked:boolean
}

const ExportAnomaly = (props: IExportAnomaly) => {
    const [allLabelData, setAllLabelData] = useState<any>([])
    const [allLabelDomainData, setAllLabelDomainData] = useState<any>([])
    const [allDomain, setAllDomain] = useState<any>([])
    const [exportPostLabel,setExportPostLabel]=useState<any>([])
    const { status: exportStatus, data: exportData } = useSelector(getExportLookupSelector);
    const exportFilter = useSelector(getAllExportFiltersSelector);
    const current_role = useSelector(getCurrentRole);

    const dispatch = useDispatch();

    useEffect(() => {
        if (exportStatus == "idle") {
            let newdata:any={"filters":[{"column":"domain_name","type":"in","value":[...props.uniqueDomain]}],"current_role":current_role}
        
            if(props.isOrphan===true){
                newdata["orphan"]=true;
              }
                  dispatch(getExportLookup(newdata))
        }
        if(exportStatus == "finished") {
            handlingDomainData();
        }
    }, [exportStatus])

    useEffect(()=>{
        let newdata:any={"filters":[{"column":"domain_name","type":"in","value":[...props.uniqueDomain]}],"current_role":current_role}
      if(props.isOrphan===true){
        newdata["orphan"]=true;
      }
      
        dispatch(getExportLookup(newdata))    
    },[props.showExportPopup])


    useEffect(()=>{
        handlingPostData();
    },[exportStatus])

    useEffect(()=>{
        handlingPostData();
    },[allLabelData,allLabelDomainData])

    useEffect(()=>{
        let applyExportFilter:any =[];
        applyExportFilter.push({column:EXPORT_LOOKUP_CONSTANTS.DEFAULT_LABEL, value:props.exportAnomayColumns,type: "in"})
        applyExportFilter.push({ column: EXPORT_LOOKUP_CONSTANTS.INSIGHT_ID, value:props.selectedInsightId, type: "in"})
        applyExportFilter.push({ column: EXPORT_LOOKUP_CONSTANTS.LABEL_GROUP , value: exportPostLabel, type: "in" })
        dispatch(addExportFilter(applyExportFilter));
    },[exportPostLabel])

    const handleDownload = ()=>{
        handlingPostData();
        if(exportFilter.length!=0){
            props.downloadExportData();
            tagEvent('AnomalyExport',{ExportCount:'EventCount'})
        }
    }

    const handlingDomainData = () => {
        if(exportData){
            let empTY:any = []
            const all_Domain:any = [];
            const all_LabelDomainData:any = [];
            const all_LabelData:any = new Object();
            exportData?.map((val: any) => {
                if(val){
                    all_Domain.push(val.domain_name)
                    all_LabelDomainData[val.domain_name] = false
                    let tempArr:any = [];
                    val.label_name?.map((data: IDomainExportData) => {
                        tempArr.push({ text: data, isChecked: false })
                    });
                    all_LabelData[val.domain_name] = tempArr;
                }
            });
            
            setAllDomain(all_Domain)
            setAllLabelData(all_LabelData)
            setAllLabelDomainData(all_LabelDomainData)
        }
    }

    const handleChange = (val: string, domain: string) => {
        let data = [...allLabelData[domain]]
        data = allLabelData[domain]?.map((labelObj: IDomainExportData, key: number) => {
            if (labelObj.text === val){
                return { ...labelObj, isChecked: !labelObj.isChecked };
            }
            return labelObj;
        });
        setAllLabelData({...allLabelData, [domain]:data})
    }

    const handleSelectAll = (domain: string) => {
        allLabelDomainData[domain] = !allLabelDomainData[domain];
        let data = [...allLabelData[domain]]
        data = allLabelData[domain]?.map((labelObj: IDomainExportData) => {
            return { ...labelObj, isChecked: allLabelDomainData[domain] };
        });
        setAllLabelData({...allLabelData, [domain]:data})
        setAllLabelDomainData({...allLabelDomainData})
    }

    const handlingPostData=()=>{
        let postData: any = {};
        Object.keys(allLabelData).forEach(domain => {
            postData[domain] = allLabelData[domain].filter((labelObj: IDomainExportData) => labelObj.isChecked == true).map((val:IDomainExportData)=> val.text)
        })
        setExportPostLabel([postData])
    }

    const handleClose=()=>{
        props.toggleClose();
        dispatch(clearExportFilter([]))
    }

    return (
        <div >
            <Modal className='export__details' closeIcon={true} open={props.showExportPopup} onClose={handleClose}>
                <Modal.Header className='header__section'>
                    <div className='export__heading'>
                        <div className='export__heading--heading'>{EXPORT_LOOKUP_CONSTANTS.EXPORT_ANOMALY_DETAIL}</div>
                        <div className='heading_note'>
                            <div className="">{EXPORT_LOOKUP_CONSTANTS.EXPORT_NOTE}</div>
                        </div>
                        <div className='heading__domain'>
                            {allDomain.map((val: any) => (
                                <div className={`heading__domain--${val.toLowerCase()}`} key={val}>{val}</div>)
                            )}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Content>
                <div className='domain__options'>
                {Object.keys(allLabelData).map((val: any) => {
                    return (
                    <>
                    <div className={`domain__options--${val.toLowerCase()}`} key={val}>
                        <Checkbox label="Select All" checked={allLabelDomainData[val]} onChange={() => handleSelectAll(val)} />
                        {Object.keys(allLabelData[val]).map((eachVal: any) => {
                            return (
                                <Checkbox label={allLabelData[val][eachVal].text} name={allLabelData[val][eachVal].text} checked={allLabelData[val][eachVal].isChecked} onChange={() => handleChange(allLabelData[val][eachVal].text,val)} />
                            )
                        })}
                    </div>
                    </>
                    )
                })}
                </div>
                </Modal.Content>
                <Modal.Footer className='export__buttons'>
                    <Button className='export__buttons--cancel'
                        type="secondary"
                        size="small"
                        content="Cancel"
                        onClick={handleClose} />
                    <Button className='export__buttons--download'
                        type="primary"
                        size="small"
                        content="Download"
                        onClick={handleDownload}
                         />
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ExportAnomaly